import { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

const useRequestDetails = (requestId, persona) => {
  const [requestDetails, setRequestDetails] = useState(null);
  
  useEffect(() => {
    const fetchRequestDetails = async () => {
      if (requestId) {
        const link = persona === "customer" ? "/api/requests/enduser" : "/api/requests";
        try {
          const response = await axiosInstance.get(
            `${link}/${requestId}`
          );
          setRequestDetails(response.data);
        } catch (error) {
          console.error("Failed to fetch request details", error);
        }
      }
    };
    fetchRequestDetails();
  }, [requestId, persona]);
  
  return requestDetails;
};

export { useRequestDetails }; 